<div class="success-full relative overflow-hidden">
    <div class="nav-actions">
        <app-lang-switcher class="white-lang-switcher"></app-lang-switcher>
        <button data-test="cop-btn-logout" class="btn btn-logout" (click)="onLogout()" translate>
            authentication.logout
        </button>
    </div>

    <section class="success pt-4">
        <div class="d-flex align-items-center justify-content-center mb-7">
            <div class="col-10">
                <button class="icon btn-muted back-to-list-button" *ngIf="showBackButton" (click)="backToList()">
                    <i class="material-icons">arrow_back</i>
                </button>
                <h1 class="title" translate>cop.helper.title</h1>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-10 no-padding d-flex">
                <finstein-search-all-table
                    class="m-auto"
                    [table]="employeeList"
                    [rows]="employees"
                    [customSearchProps]="[{ prop: 'deletedEmail' }]"
                    searchPlaceholder="cop.helper.search-employees"
                ></finstein-search-all-table>
            </div>

            <div class="col-10 mt-4 no-padding employees-table-container">
                <ng-scrollbar class="employees-scrollbar">
                    <ngx-datatable
                        #employeeList
                        class="material expandable employees-datatable"
                        columnMode="force"
                        [headerHeight]="50"
                        [footerHeight]="50"
                        [rowHeight]="50"
                        [rows]="employees"
                        [loadingIndicator]="loadingEmployees"
                        [scrollbarH]="true"
                        [virtualization]="false"
                        [externalPaging]="false"
                    >
                        <ngx-datatable-column
                            [sortable]="true"
                            [name]="
                                'cop.helper.employees.last-name' | translate
                            "
                            prop="lastName"
                        ></ngx-datatable-column>

                        <ngx-datatable-column
                            [sortable]="true"
                            [canAutoResize]="true"
                            [name]="
                                'cop.helper.employees.first-name' | translate
                            "
                            prop="firstName"
                        ></ngx-datatable-column>

                        <ngx-datatable-column
                            [sortable]="true"
                            [canAutoResize]="true"
                            [name]="'cop.helper.employees.email' | translate"
                            prop="email"
                        ></ngx-datatable-column>

                        <ngx-datatable-column
                            [sortable]="true"
                            [canAutoResize]="true"
                            [name]="
                                'cop.helper.employees.company-name' | translate
                            "
                            prop="companyName"
                        ></ngx-datatable-column>

                        <ngx-datatable-column
                            [sortable]="true"
                            [canAutoResize]="true"
                            [name]="'cop.helper.employees.status' | translate"
                            cellClass="d-inline-flex align-items-center justify-content-center"
                        >
                            <ng-template
                                let-row="row"
                                ngx-datatable-cell-template
                            >
                                <finstein-datatable-status-column
                                    [resolveStatus]="false"
                                    [customStatusValue]="row.status"
                                    [statusClass]="row.status"
                                    [row]="row"
                                ></finstein-datatable-status-column>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column
                            [name]="'cop.helper.employees.actions' | translate"
                            [sortable]="true"
                            [draggable]="false"
                            [canAutoResize]="true"
                            cellClass="datatable-body-cell-buttons"
                        >
                            <ng-template
                                let-row="row"
                                ngx-datatable-cell-template
                            >
                                <button
                                    class="btn-action ml-1"
                                    (click)="onSelectEployee(row)"
                                    matRipple
                                >
                                    <i class="material-icons">check</i>
                                </button>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </ng-scrollbar>

                <finstein-search-column
                    [table]="employeeList"
                    [rows]="employees"
                ></finstein-search-column>
            </div>
        </div>
    </section>
</div>
